module.exports = __webpack_public_path__ + "img/GlusterFS.d91791f.svg";